<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_ConflictExpenseDetails')"
      :show-close="false"
      @close="cancel"
    >
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'100%',height:'300px'}"
      />
      <div slot="footer">
        <div style="position:absolute;left: 40px;">
          <span>{{ $t('CargoMsg.Cargo_TEYAPHBMBSEC') }}</span>
        </div>
        <div>
          <el-button type="primary" no="1" size="mini" @click="continueEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
          <el-button size="mini" no="2" @click="cancel">{{ $t('Billing.billingView_Close') }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'ConflictChargeDialog',
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    charges: { type: Array, required: true }, // 弹框打开时默认传递条件
    viewSource: { type: String, required: true } // 请求来源
  },
  data() {
    return {
      innerVisible: this.visible,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: this.charges ? this.charges : []
    }
  },
  computed: {},
  created() {
    this.columnDefs = [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Payment.businessNumber'), field: 'jobNo', width: 200 },
      { headerName: this.$t('Payment.settleAccountsTo'), field: 'accountId', width: 200,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeItemId', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Billing.billingCharge_amount'), field: 'quantity', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_unitPrice'), field: 'unitRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.billingJob_taxIncludedPrice'), field: 'amount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.number2ColumnLabelFunc(params.value)
        } },
      { headerName: this.$t('Billing.modifiedBy'), field: 'modifiedBy', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.dateModified'), field: 'dateModified', width: 150 }
    ]
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      const viewSource = this.viewSource
      if (viewSource === 'billingDetail') {
        this.$emit('conflictChargeCallBackEvent', { type: false, charges: [] })
      } else if (viewSource === 'reconciliation') {
        this.$emit('conflictChargeCallBackEventToReconciliation', { type: false, charges: [] })
      }
    },
    continueEvent() {
      const viewSource = this.viewSource
      if (viewSource === 'billingDetail') {
        this.$emit('conflictChargeCallBackEvent', { type: true, charges: this.rowData })
      } else if (viewSource === 'reconciliation') {
        this.$emit('conflictChargeCallBackEventToReconciliation', { type: true, charges: this.rowData })
      }
    }
  }
}
</script>
